module.exports = __webpack_public_path__ + "img/capture.03a4ce5d.svg";